export default {"src":"/_next/static/media/bike_24.6286657c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};